import React from 'react'
import { TimelineLite, TweenLite } from 'gsap'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'

const NoticesHOC = (WrappedComponent) => {
    return class extends React.Component {
        componentDidMount () {
            this.showNotice()
            document.addEventListener('keydown', this.handleKeyPress.bind(this))
        }

        componentWillUnmount () {
            document.removeEventListener('keydown', this.handleKeyPress.bind(this))
        }

        handleKeyPress (event) {
            if (event.code === 'Escape') {
                this.hideNotice()
            }
        }

        showNotice () {
            setTimeout(() => {
                TweenLite.set('body', { css: { overflow: 'hidden' } })
                TweenLite.to(this.container, 0.5, { opacity: 1 })
            }, 250)
        }

        hideNotice () {
            TweenLite.set('body', { css: { overflow: 'visible' } })
            const tl = new TimelineLite()
            tl.to(this.container, 0.25, { opacity: 0 })
            tl.set(this.container, { display: 'none' })
            this.setViewedVar()
        }

        setViewedVar () {
            this.props.setModalSeen(this.props.customerId, this.props.type)
        }

        handleCloseClick (event) {
            event.preventDefault()
            this.hideNotice()
        }

        render () {
            return (
                <div className='notice module terms' ref={el => this.container = el} style={{ opacity: 0 }}>
                    <div className='notice-inner'>
                        <Heading title={this.props.title} />
                        <ModuleWithLoader isLoaded hasError={this.props.hasError} className='p-4'>
                            <WrappedComponent
                                hideNotice={this.hideNotice.bind(this)}
                                {...this.props}
                            >
                                {this.props.children}
                            </WrappedComponent>
                        </ModuleWithLoader>
                        <a href='#' className='close-btn' onClick={this.handleCloseClick.bind(this)}><img src='/images/icon-close-white.svg' alt='Close' /></a>
                    </div>
                </div>
            )
        }
    }
}

export default NoticesHOC



// WEBPACK FOOTER //
// ./resources/js/modules/NoticesHOC.js